import { createFileRoute } from "@tanstack/react-router";
import { CyclesPage, type CyclesSearch } from "@/components/cycles/cycles-page";

export const Route = createFileRoute("/_app/$workspaceSlug/cycles")({
  // Which cycle is shown and whose issues live in the URL. A number that is
  // not a cycle's (a whole number from 1) is the current cycle; one that is
  // but does not exist says so on the page.
  validateSearch: (search: Record<string, unknown>): CyclesSearch => {
    const number = typeof search.number === "string" ? Number(search.number) : search.number;
    return {
      ...(typeof number === "number" && Number.isSafeInteger(number) && number >= 1 ? { number } : {}),
      ...(search.who === "mine" ? { who: "mine" as const } : {}),
    };
  },
  component: CyclesRoute,
});

function CyclesRoute() {
  const { workspaceSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CyclesPage
      key={workspaceSlug}
      search={search}
      onSearchChange={(next) => void navigate({ search: next })}
    />
  );
}
